import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Project} from "../../models/project";
import {tap} from "rxjs/operators";
import {Structure} from "../../models/structure";

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private readonly PROJECT_ID = 'PROJECT_ID';

  public project: Project = null;
  public projects: Array<Project> = [];
  public onSelect: EventEmitter<string> = new EventEmitter<string>();
  public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient,
  ) {
  }

  getAllMyProjects() {
    return this.http.get('/api/v1/projects').pipe(
      tap(data => this.projects = data['data']['projects'])
    )
  }

  postProject(name) {
    return this.http.post('/api/v1/projects', {name}).pipe(
      tap(
        data => {
          this.projects.push(data['data']['project']);
          this.onChange.emit(true);
        },
        err => console.error(err)
      )
    );
  }

  getSingleProject(id) {
    return this.http.get('/api/v1/projects/' + id).pipe(
      tap(
        data => {
          this.project = new Project(data['data']['project']);

          const index = this.projects.findIndex(p => p["_id"] === data["data"]["project"]["_id"]);

          if (index > -1)
            this.projects[index] = this.project;
        },
        err => console.error(err)
      )
    );
  }

  deleteProject(id) {
    return this.http.delete('/api/v1/projects/' + id).pipe(
      tap(
        data => {
          this.projects.splice(this.projects.findIndex(p => p["_id"] === data["data"]["project"]["_id"]), 1);

          this.onChange.emit(true);
        },
        err => console.error(err)
      )
    );
  }

  patchProject(id, name) {
    return this.http.patch('/api/v1/projects/' + id, {name}).pipe(
      tap(
        data => {
          this.project = new Project(data["data"]["project"]);

          const index = this.projects.findIndex(p => p["_id"] === data["data"]["project"]["_id"]);

          if (index > -1)
            this.projects[index] = this.project;

          this.onChange.emit(true);

          return data['data']['project'];
        },
        err => console.error(err)
      )
    );
  }

  exportProjectCsv(id) {
    return this.http.get('/api/v1/projects/' + id + '/export/csv', {
      observe: 'response',
      responseType: 'blob'
    }).pipe(tap
    (response => {
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'downloaded-file';

      if (contentDisposition) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = new Blob([response.body], {type: response.body.type});
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();

      window.URL.revokeObjectURL(url);
    }));
  }
}
